module.exports = __webpack_public_path__ + "img/shop-pic-01.6201de26.png";